<app-enfaf-modal
  title="Popup embajadores"
  (onConfirm)="savePopup()"
  (onClose)="confirmCloseModal()"
  [disableConfirmButton]="popupForm.invalid || isSaving"
  [isLoading]="isSaving"
  svgIcon="star"
>
  @if (popupForm) {
    <form [formGroup]="popupForm" autocomplete="off" class="popup-form-container">
      <!-- Información del popup -->
      <app-enfaf-expansion-panel-light title="Información del popup" [isExpanded]="true">
        <div class="form-section">
          <div class="form-row">
            <enfaf-input
              [control]="popupForm.get('description')!"
              label="Descripción"
              placeholder="Descripción del popup"
              errorLabel="La descripción es requerida (máx. 500 caracteres)"
              description="Este texto será visible debajo del popup"
              color="light"
            />

            <enfaf-input
              [control]="popupForm.get('link')!"
              label="Enlace"
              placeholder="https://..."
              errorLabel="El enlace es requerido y debe ser una URL válida"
              color="light"
            />
          </div>
        </div>
      </app-enfaf-expansion-panel-light>

      <!-- Disponibilidad -->
      <app-enfaf-expansion-panel-light title="Disponibilidad" [isExpanded]="true">
        <div class="form-section">
          <div class="form-row">
            <enfaf-select-light
              label="¿Cuándo aparece el Popup?"
              [control]="popupForm.get('popupTrigger')!"
              [options]="triggerOptions"
              errorLabel="Selecciona cuándo debe aparecer el popup"
            />

            @if (showTriggerThreshold) {
              <enfaf-input
                [control]="popupForm.get('triggerThreshold')!"
                [label]="triggerThresholdLabel"
                type="number"
                placeholder="0"
                errorLabel="El valor debe ser mayor a 0"
                color="light"
              />
            }
          </div>

          <div class="form-row">
            <enfaf-select-light
              label="¿Quién puede ver el popup?"
              [control]="popupForm.get('popupAudience')!"
              [options]="audienceOptions"
              errorLabel="Selecciona la audiencia del popup"
            />
            @if (showCoursesSelection) {
              <enfaf-multi-autocomplete-light
                #coursesAutocomplete
                [label]="'Seleccionar cursos'"
                [placeholder]="'Buscar cursos'"
                [fetchData]="fetchCourses"
                [selectedOptions]="selectedCourses"
                (selectedChanged)="onCoursesSelectionChange($event)"
              />
            }
            @if (showUsersSelection) {
              <enfaf-multi-autocomplete-light
                #usersAutocomplete
                [label]="'Seleccionar usuarios'"
                [placeholder]="'Buscar usuarios'"
                [fetchData]="fetchUsers"
                [selectedOptions]="selectedUsers"
                (selectedChanged)="onUsersSelectionChange($event)"
              />
            }
          </div>

          <!-- Selección de cursos -->
          @if (showCoursesSelection && selectedCourses.length > 0) {
            <div class="selected-courses-container">
              <div class="selected-courses-title">Cursos seleccionados:</div>
              <div class="selected-courses-list">
                @for (course of selectedCourses; track course.id) {
                  <div class="course-item">
                    <span class="course-name">{{ course.title }}</span>
                    <app-enfaf-icon
                      svgIconName="trash-red"
                      iconSize="16px"
                      [iconStyle]="{ color: '#E03131' }"
                      [isButton]="true"
                      (onClick)="removeCourse(course)"
                      class="remove-icon"
                    />
                  </div>
                }
              </div>
            </div>
          }

          <!-- Selección de usuarios -->
          @if (showUsersSelection && selectedUsers.length > 0) {
            <div class="selected-courses-container">
              <div class="selected-courses-title">Usuarios seleccionados:</div>
              <div class="selected-courses-list">
                @for (user of selectedUsers; track user.id) {
                  <div class="course-item">
                    <span class="course-name">{{ user.title }}</span>
                    <app-enfaf-icon
                      svgIconName="trash-red"
                      iconSize="16px"
                      [iconStyle]="{ color: '#E03131' }"
                      [isButton]="true"
                      (onClick)="removeUser(user)"
                      class="remove-icon"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </app-enfaf-expansion-panel-light>

      <!-- Imagen -->
      <app-enfaf-expansion-panel-light title="Imagen" [isExpanded]="true">
        <div class="form-section">
          <app-enfaf-img-dragger
            [urlImage]="popupForm.value.popupImageUrl ?? ''"
            (onImageUpload)="uploadImage($event)"
            (onImageDelete)="deleteImage()"
            minHeight="250px"
            width="100%"
            objectFit="contain"
          >
            <p slot-text>
              Subir imagen popup
              <br />
              Tamaño recomendado de <strong>1100 x 550px</strong>
            </p>
          </app-enfaf-img-dragger>
        </div>
      </app-enfaf-expansion-panel-light>
    </form>
  }
</app-enfaf-modal>
